import { IImportActionsTypes } from './importActionTypes'

export enum ImportTypes {
  SET_PERCENTAGE = 'IMPORT_SET_PERCENTAGE',
  SET_STATUS = 'IMPORT_SET_STATUS',
  SET_ANTD_STATUS = 'IMPORT_SET_ANTD_STATUS',
  SET_IMPORT_FILE = 'SET_IMPORT_FILE',
  RESET = 'PROGRESS_QUEUE_RESET'
}

export const ImportActions = {
  setImportItem: (
    payload: IImportActionsTypes.setImportItem['payload']
  ): IImportActionsTypes.setImportItem => ({
    type: ImportTypes.SET_IMPORT_FILE,
    payload
  }),

  setStatus: (
    payload: IImportActionsTypes.setStatus['payload']
  ): IImportActionsTypes.setStatus => ({
    type: ImportTypes.SET_STATUS,
    payload
  }),

  setAntdStatus: (
    payload: IImportActionsTypes.setAntdStatus['payload']
  ): IImportActionsTypes.setAntdStatus => ({
    type: ImportTypes.SET_ANTD_STATUS,
    payload
  }),

  setPercentage: (
    payload: IImportActionsTypes.setPercentage['payload']
  ): IImportActionsTypes.setPercentage => ({
    type: ImportTypes.SET_PERCENTAGE,
    payload
  }),

  reset: (): IImportActionsTypes.reset => ({
    type: ImportTypes.RESET
  })
}
